import React from "react";

const Loader = () => {
  return (
    <div className="loaderWrapper">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
